import React from "react";
import type { ReviewSummaryStep } from "../opportunityFormTypes";

type TranslateFn = (key: string) => string;

type ReviewStepProps = {
  allStepsValid: boolean;
  isEditMode: boolean;
  summaries: ReviewSummaryStep[];
  t: TranslateFn;
};

export const ReviewStep: React.FC<ReviewStepProps> = ({
  allStepsValid,
  isEditMode,
  summaries,
  t,
}) => (
  <div className="border border-gray-200 rounded-xl overflow-hidden">
    <div className="px-4 py-3 bg-gray-50 border-b border-gray-200 flex items-center justify-between">
      <div>
        <p className="text-xs font-bold text-gray-800">
          {t("reviewConfirm")}
        </p>
        <p className="text-[11px] text-gray-500 mt-0.5">
          {t(
            isEditMode
              ? "checkDetailsBeforeSaving"
              : "checkDetailsBeforeCreating",
          )}
        </p>
      </div>
      <span
        className={`text-[11px] font-semibold px-2.5 py-0.5 rounded-full border ${allStepsValid
            ? "bg-green-50 text-green-700 border-green-300"
            : "bg-yellow-50 text-yellow-700 border-yellow-300"
          }`}
      >
        {allStepsValid ? `✓ ${t("ready")}` : t("incompleteFields")}
      </span>
    </div>
    <div className="divide-y divide-gray-100">
      {summaries.map((stepSummary) => (
        <div key={stepSummary.stepId} className="px-5 py-4">
          <p className="text-[10px] font-bold text-gray-400 uppercase tracking-wider mb-2">
            {stepSummary.title}
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-2">
            {stepSummary.fields.map((reviewField) => (
              <div key={reviewField.label}>
                <p className="text-[10px] text-gray-400 mb-0.5">
                  {reviewField.label}
                  {reviewField.required && (
                    <span className="text-red-400 ml-0.5">*</span>
                  )}
                </p>
                <p
                  className={`text-xs font-semibold truncate ${reviewField.display === "—" ? "text-gray-300" : "text-gray-800"
                    }`}
                >
                  {reviewField.display}
                </p>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  </div>
);